import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1024b434")
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "pop-btn-wrap" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_van_cell_group, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: _ctx.tel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.tel = $event)),
          required: "",
          type: "tel",
          placeholder: "请输入手机号",
          "left-icon": "phone-o"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          modelValue: _ctx.sms,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sms = $event)),
          center: "",
          type: "digit",
          clearable: "",
          placeholder: "请输入短信验证码",
          "left-icon": "envelop-o"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_van_button, {
              class: "send-btn",
              size: "small",
              onClick: _ctx.sendCode,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.time == 60 ? "获取验证码" : _ctx.time), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onLogin && _ctx.onLogin(...args)))
      }, "登 录")
    ])
  ]))
}